import { Colors } from '@mercator-gcp/grout';
import WrappedList from 'components/layout/WrappedList';
import ProjectActivityCard from 'components/widgets/ProjectDetails/ProjectActivityCard';
import { Project } from 'types';
import { ActivitySummary } from 'types/ActivitySummary';

const tableItem = {
  width: '100%',
  border: 'none',
  padding: 'padding_8',
  _hover: {
    background: Colors.ArmyGreen100,
  },
};

type Props = {
  summarizedActivityList: ActivitySummary[];
  projectSlug?: Project['slug'];
  showCompanyContacts?: boolean;
};

const LatestActivityTable = ({
  projectSlug,
  summarizedActivityList,
  showCompanyContacts,
}: Props) => {
  return (
    <WrappedList aria-label="summary of project stages">
      {summarizedActivityList.map((activitySummary) => {
        return (
          <WrappedList.Item
            className="no-break-on-print"
            sx={tableItem}
            key={`project-activity-card-${activitySummary.date}-${activitySummary.latest_activity.document_uuid}`}
          >
            <ProjectActivityCard
              activitySummary={activitySummary}
              projectSlug={projectSlug}
              showCompanyContacts={showCompanyContacts}
            />
          </WrappedList.Item>
        );
      })}
    </WrappedList>
  );
};

export default LatestActivityTable;
